import React, { useRef } from 'react';
import {
  App,
  Button,
  DatePicker,
  Dropdown,
  Flex,
  Input,
  Popconfirm,
  Popover,
  Space,
  Tag,
} from 'antd';
import { MdDelete, MdModeEditOutline, MdVisibility } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { deleteSalesInvoice, submitDoc } from '../../network/PaymentEntry';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { BiSolidBank } from 'react-icons/bi';
import StatusTag from '../../hooks/StatusHook';
import { GiFiles } from 'react-icons/gi';
import { cancelMaterialRequest } from '../../network/materialRequest';
import { TiCancel } from 'react-icons/ti';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { colorPrimary } from '../../utils/utils';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import dayjs from 'dayjs';
import { ModalAddBankTransfer } from '../../components/upeosoft/ModalApp/ModalApp';
import { TbDotsVertical } from 'react-icons/tb';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import UseDownloadPdf from '../../hooks/DownloadPdf';
const PaymentAction = ({ t }) => {
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const [openBankTransfer, setOpenBankTransfer] = useState(false);
  const [idPayment, setIdPayment] = useState('');
  const { onGetPDF, pdfData, setLoadingPdf, loadingPdf } = UseDownloadPdf();
  const [nameInvoice, setNameInvoice] = useState('');
  const [openPdf, setOpenPdf] = useState(false);
  const navigate = useNavigate();
  const { message } = App.useApp();
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };
  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const { mutate: onSubmitSalesInvoice } = useMutation({
    mutationKey: ['submitDoc'],
    mutationFn: (name) => submitDoc(name),
    onSuccess: (data) => {
      if (data?.message?.status === 500) {
        message.error('Something went wrong!');
        return false;
      }
      client.invalidateQueries({
        queryKey: [
          queryKeys.getPaymentEntries,
          searchText.key,
          searchText.value,
        ],
      });
      client.invalidateQueries({
        queryKey: [
          queryKeys.getPaymentReceiptVoucher,
          searchText.key,
          searchText.value,
        ],
      });
      client.invalidateQueries({
        queryKey: [
          queryKeys.getPaymentVoucher,
          searchText.key,
          searchText.value,
        ],
      });
      data?.message?.message && message.success(data?.message?.message);
    },
    onError: (error) => {
      message.error('Something went wrong!');
    },
  });

  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteSalesInvoice(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({
          queryKey: [
            queryKeys.getPaymentEntries,
            searchText.key,
            searchText.value,
          ],
        });
        client.invalidateQueries({
          queryKey: [
            queryKeys.getPaymentReceiptVoucher,
            searchText.key,
            searchText.value,
          ],
        });
        client.invalidateQueries({
          queryKey: [
            queryKeys.getPaymentVoucher,
            searchText.key,
            searchText.value,
          ],
        });
      },
      onError: () => {
        message.error('Something went wrong!');
      },
    }
  );
  const handleCancel = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (name) => cancelMaterialRequest('Payment Entry', name),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success('Cancelled successfully');
        client.invalidateQueries({
          queryKey: [
            queryKeys.getPaymentEntries,
            searchText.key,
            searchText.value,
          ],
        });
        client.invalidateQueries({
          queryKey: [
            queryKeys.getPaymentReceiptVoucher,
            searchText.key,
            searchText.value,
          ],
        });
        client.invalidateQueries({
          queryKey: [
            queryKeys.getPaymentVoucher,
            searchText.key,
            searchText.value,
          ],
        });
      },
      onError: () => {
        message.error('Something went wrong!');
      },
    }
  );
  const items = (record) => [
    {
      key: '1',
      label: t.edit,
      icon: record?.docstatus === 0 ? <MdModeEditOutline /> : <MdVisibility />,
      onClick: () => navigate(`/payment-entry/${record?.name}`),
    },
    {
      key: '4',
      label: t.GeneralLedger,
      icon: <GiFiles />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () =>
        navigate(`/general-ledger-report-payment-entry/${record?.name}`),
    },
    {
      key: '4-4',
      label: t.BankTransfer,
      icon: <BiSolidBank />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => {
        setOpenBankTransfer(true);
        setIdPayment(record?.name);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '6',
      label: t.getPDF,
      icon: <CheckOutlined />,
      onClick: () => {
        onGetPDF({
          type: 'Payment Entry',
          name: record.name,
          lang: currentLang,
        });
        setNameInvoice(record.name);
        setOpenPdf(true);
      },
    },
    {
      key: '5',
      label: t.SubmitthePaymentEntry,
      disabled: record.status === 'Draft' ? false : true,
      icon: <CheckOutlined />,
      onClick: () => onSubmitSalesInvoice(record?.name),
    },
    {
      key: '8',
      label: t.cancelthePaymentEntry,
      icon: <CloseCircleOutlined />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => handleCancel.mutate(record?.name),
    },
    {
      type: 'divider',
    },
    {
      key: '9',
      disabled: record?.docstatus === 1 ? true : false,
      label: (
        <Popconfirm
          title={t.Deletethepaymententry + ` (${record?.name})`}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: currentLang === 'en' ? 'ID' : 'الرقم',
      dataIndex: 'name',
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/payment-entry/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
      ...props({ key: 'name', name: currentLang === 'en' ? 'ID' : 'الرقم' }),
    },
    {
      title: currentLang === 'en' ? 'Party Name' : 'اسم الحزب',
      dataIndex: 'party',
      // filteredValue: [searchText],
      // onFilter: (value, record) => {
      //   const name = String(record.party).toLowerCase();
      //   const id = String(record.name).toLowerCase();
      //   const searchValue = value.toLowerCase();
      //   return name.includes(searchValue) || id.includes(searchValue);
      // },
      ...props({
        key: 'party',
        name: currentLang === 'en' ? 'Party Name' : 'اسم الحزب',
      }),
    },
    {
      title: currentLang === 'en' ? 'Payment Type' : 'نوع الدفع',
      dataIndex: 'payment_type',
      ...props({
        key: 'payment_type',
        name: currentLang === 'en' ? 'Payment Type' : 'نوع الدفع',
      }),
    },
    {
      title: currentLang === 'en' ? 'Mode of Payment' : 'طريقة الدفع',
      dataIndex: 'mode_of_payment',
      ...props({
        key: 'mode_of_payment',
        name: currentLang === 'en' ? 'Mode of Payment' : 'طريقة الدفع',
      }),
    },
    {
      title: currentLang === 'en' ? 'Posting Date' : 'تاريخ النشر',
      dataIndex: 'posting_date',
      // ...props({ key: 'posting_date', name: currentLang === 'en' ? 'Posting Date' : 'تاريخ النشر'}),
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Flex vertical gap={16}>
            <DatePicker
              onChange={(date) => {
                // console.log(dayjs(date)?.format('YYYY-MM-DD'), 'posting_date');
                if (date) {
                  setSearchText({
                    value: dayjs(date)?.format('YYYY-MM-DD'),
                    key: 'posting_date',
                  });
                } else {
                  setSearchText({ value: '', key: '' });
                }
              }}
            />
          </Flex>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: currentLang === 'en' ? 'Total Amount' : 'المبلغ الكلي',
      dataIndex: 'total_allocated_amount',
      ...props({
        key: 'total_allocated_amount',
        name: currentLang === 'en' ? 'Total Amount' : 'المبلغ الكلي',
      }),
    },
    {
      title: currentLang === 'en' ? 'Status' : 'حالة',
      dataIndex: 'status',
      render: (status, record) => <StatusTag status={record?.docstatus} />,
      ...props({
        key: 'status',
        name: currentLang === 'en' ? 'Status' : 'حالة',
      }),
    },
    {
      title: t.action,
      dataIndex: 'docstatus',
      key: 'docstatus',
      render: (text, record) => {
        const enable_submit = record?.status === 'Draft' ? true : false;
        return (
          // <Space>
          //   <Dropdown
          //     menu={{ items: items(record) }}
          //     trigger={['click']}
          //     // placement="bottomCenter"
          //   >
          //     <Button
          //       size="small"
          //       type="text"
          //       icon={<TbDotsVertical size={20} />}
          //     />
          //   </Dropdown>
          // </Space>
          <>
            <Dropdown
              menu={{ items: items(record) }}
              // placement="bottomRight"
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </>
        );
      },
    },
  ];

  return {
    columns,
    searchText,
    setSearchText,
    idPayment,
    openBankTransfer,
    setOpenBankTransfer,
    openPdf,
    pdfData,
    setOpenPdf,
    nameInvoice,
    onGetPDF,
    setLoadingPdf,
    loadingPdf,
  };
};

export default PaymentAction;

// import React, { useRef } from 'react'
// import { App, Button, Input, Popconfirm, Popover, Space, Tag } from 'antd';
// import { MdDelete, MdModeEditOutline, MdVisibility } from 'react-icons/md';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { useState } from 'react';
// import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
// import { queryKeys } from '../../services/react-query/queryKeys';
// import {
//   deleteSalesInvoice,
//   submitDoc,
// } from '../../network/PaymentEntry';
// import { FaFileInvoiceDollar } from 'react-icons/fa';
// import StatusTag from '../../hooks/StatusHook';
// import { GiFiles } from 'react-icons/gi';
// import { cancelMaterialRequest } from '../../network/materialRequest';
// import { TiCancel } from 'react-icons/ti';
// import {SearchOutlined} from '@ant-design/icons'
// import { colorPrimary } from '../../utils/utils';
// import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
// const PaymentAction = ({ t }) => {
//     const client = useQueryClient();
//     const { currentLang } = useSelector((state) => state.user);
//     const navigate = useNavigate();
//     const { message } = App.useApp();
//     const searchInput = useRef(null);
//     const searchInputMobile = useRef(null);
//     const [textValue, setTextValue] = useState('');
//     // const [searchText, setSearchText] = useState('')
//     const [searchText, setSearchText] = useState({
//       value: '',
//       key: '',
//     });
//     console.log(searchText, 'searchTextwjwjifjwio');

//     const handleSearch = (selectedKeys, confirm, key) => {
//       // console.log(selectedKeys);
//       confirm();
//       setSearchText({ value: selectedKeys[0], key: key });
//     };
//     const handleReset = (clearFilters, confirm) => {
//       confirm();
//       setTextValue('');
//       clearFilters();
//       setSearchText({ value: '', key: '' });
//     };

//     const { mutate: onSubmitSalesInvoice } = useMutation({
//         mutationKey: ['submitDoc'],
//         mutationFn: (name) => submitDoc(name),
//         onSuccess: (data) => {
//           if (data?.message?.status === 500) {
//             message.error("Something went wrong!");
//             return false;
//           }
//           data?.message?.message && message.success(data?.message?.message);
//           client.invalidateQueries({
//             queryKey: [queryKeys.getPaymentEntries],
//           });
//         },
//         onError: (error) => {
//           message.error('Something went wrong!');
//         },
//       });

//       const handleRemove = useMutation(
//         // (id) => deletePatient(id),
//         {
//           mutationFn: (id) => deleteSalesInvoice(id),
//           onSuccess: (data) => {
//             // console.log(data, 'data');
//             if (data?.message?.status === 500) {
//               message.error(data?.message?.message);
//               return false;
//             }
//             message.success(data?.message?.message);
//             client.invalidateQueries({
//               queryKey: [queryKeys.getPaymentEntries],
//             });
//           },
//           onError: () => {
//             message.error('Something went wrong!');
//           },
//         }
//       );
//       const  handleCancel = useMutation(
//         // (id) => deletePatient(id),
//         {
//           mutationFn: (name) => cancelMaterialRequest("Payment Entry",name),
//           onSuccess: (data) => {
//             console.log(data, 'data');
//             if (data?.message?.status === 500) {
//               message.error(data?.message?.message);
//               return false;
//             }
//             message.success("Cancelled successfully");
//             client.invalidateQueries({ queryKey: [queryKeys.getPaymentEntries] });
//           },
//           onError: () => {
//             message.error('Something went wrong!');
//           },
//         }
//       );
//       const props = ({key,name}) => ({
//         filterIcon: () => <SearchOutlined color={colorPrimary} />,
//         filterDropdown: ({
//           setSelectedKeys,
//           selectedKeys,
//           confirm,
//           clearFilters,
//         }) => (
//           <div
//             style={{
//               padding: 8,
//             }}
//             onKeyDown={(e) => e.stopPropagation()}
//           >
//             <Input
//               ref={searchInputMobile}
//               placeholder={name}
//               value={textValue}
//               onChange={(e) => {
//                 setSelectedKeys(e.target.value ? [e.target.value] : []);
//                 setTextValue(e.target.value);
//               }}
//               onPressEnter={() => handleSearch(selectedKeys, confirm, key)}
//               style={{
//                 marginBottom: 8,
//                 display: 'block',
//               }}
//             />
//             <Space>
//               <Button
//                 type="primary"
//                 onClick={() => {
//                   console.log(selectedKeys,confirm, key,"dwdwdwdw");
//                   handleSearch(selectedKeys, confirm, key)
//                 } }
//                 icon={<SearchOutlined />}
//                 size="small"
//                 style={{
//                   width: 90,
//                 }}
//               >
//                 {t.Search}
//               </Button>
//               <Button
//                 onClick={() => clearFilters && handleReset(clearFilters, confirm)}
//                 size="small"
//                 style={{
//                   width: 90,
//                 }}
//               >
//                 {t.Reset}
//               </Button>
//             </Space>
//           </div>
//         ),
//         onFilterDropdownOpenChange: (visible) => {
//           if (visible) {
//             setTextValue('');
//             setSearchText({ value: '', key: '' });
//             setTimeout(() => searchInput.current?.select(), 100);
//           }
//         },
//       })
//       const columns = [
//         {
//           title: currentLang === 'en' ? 'ID' : 'الرقم',
//           dataIndex: 'name',
//           render: (text, record) => {
//             return (
//               <span
//                 style={{ cursor: 'pointer' }}
//                 className="text-primary"
//                 onClick={() => {
//                   navigate(`/payment-entry/${record.name}`);
//                 }}
//               >
//                 {text}
//               </span>
//             );
//           },
//           ...props({ key: 'name', name: currentLang === 'en' ? 'ID' : 'الرقم' }),
//         },
//         {
//           title: currentLang === 'en' ? 'Party Name' : 'اسم الحزب',
//           dataIndex: 'party',
//           // filteredValue: [searchText],
//           // onFilter: (value, record) => {
//           //   const name = String(record.party).toLowerCase();
//           //   const id = String(record.name).toLowerCase();
//           //   const searchValue = value.toLowerCase();
//           //   return name.includes(searchValue) || id.includes(searchValue);
//           // },
//           ...props({ key: 'party', name: currentLang === 'en' ? 'Party Name' : 'اسم الحزب'}),
//         },
//         {
//           title: currentLang === 'en' ? 'Payment Type' : 'نوع الدفع',
//           dataIndex: 'payment_type',
//           ...props({ key: 'payment_type', name: currentLang === 'en' ? 'Payment Type' : 'نوع الدفع'}),
//         },
//         {
//           title: currentLang === 'en' ? 'Mode of Payment' : 'طريقة الدفع',
//           dataIndex: 'mode_of_payment',
//           ...props({ key: 'mode_of_payment', name: currentLang === 'en' ? 'Mode of Payment' : 'طريقة الدفع'}),
//         },
//         {
//           title: currentLang === 'en' ? 'Posting Date' : 'تاريخ النشر',
//           dataIndex: 'posting_date',
//           ...props({ key: 'posting_date', name: currentLang === 'en' ? 'Posting Date' : 'تاريخ النشر'}),
//         },
//         {
//           title: currentLang === 'en' ? 'Total Amount' : 'المبلغ الكلي',
//           dataIndex: 'total_allocated_amount',
//           ...props({ key: 'total_allocated_amount', name: currentLang === 'en' ? 'Total Amount' : 'المبلغ الكلي'}),
//         },
//         // {
//         //   title: currentLang === 'en' ? 'Paid Amount' : 'المبلغ المدفوع',
//         //   dataIndex: 'paid_amount',
//         // },
//         {
//           title: currentLang === 'en' ? 'Status' : 'حالة',
//           dataIndex: 'status',
//           render: (status) => <StatusTag status={status} />,
//           ...props({ key: 'status', name: currentLang === 'en' ? 'Status' : 'حالة'}),
//         },
//         {
//           title: t.action,
//           dataIndex: 'docstatus',
//           key: 'docstatus',
//           render: (text, record) => {
//             const enable_submit = record?.status === 'Draft' ? true : false;
//             return (
//               <Space>
//                 <Button
//                   size="small"
//                   type="primary"
//                   onClick={() => navigate(`/payment-entry/${record?.name}`)}
//                 >
//                   {text === 0 ? <MdModeEditOutline /> : <MdVisibility />}
//                 </Button>
//                 {enable_submit && (
//                   <Popconfirm
//                     title={t.SubmitthePaymentEntry}
//                     description={t.areYouSure}
//                     onConfirm={() => onSubmitSalesInvoice(record.name)}
//                     // onCancel={cancel}
//                     okText={t.yes}
//                     cancelText={t.no}
//                   >
//                     <Popover
//                       placement="top"
//                       title={t.submit}
//                       // onConfirm={() => onSubmitSalesInvoice(record.name)}
//                     >
//                       <Button
//                         size="small"
//                         type="primary"
//                         style={{ backgroundColor: '#28a745', border: 0 }}
//                       >
//                         <FaFileInvoiceDollar />
//                       </Button>
//                     </Popover>
//                   </Popconfirm>
//                 )}
//                             {record?.docstatus === 1 &&
//             <Popover
//               placement="top"
//               title={t.GeneralLedger}
//               onClick={() => {
//                 navigate(`/general-ledger-report-payment-entry/${record?.name}`);
//               }}
//             >
//               <Button size="small" type="primary"
//               icon={<GiFiles />}
//               style={{
//                 backgroundColor: '#c12f6e',
//               }}
//               />
//               </Popover>

//       }
//                   {
//               record?.docstatus === 1 &&
//               <Popconfirm
//               title={t.cancelthePaymentEntry}
//               description={t.AreyousuretoCancelthisPaymentEntry}
//               onConfirm={() => handleCancel.mutate(record.name)}
//               // onCancel={cancel}
//               okText="Yes"
//               cancelText="No"
//               >
//               <Button size="small" type="primary" danger
//                icon={<TiCancel />}
//               />
//             </Popconfirm>
//             }
//                  {
//               record?.docstatus !== 1 &&
//                 <Popconfirm
//                   title={t.Deletethepaymententry}
//                   description={t.areYouSure}
//                   onConfirm={() => handleRemove.mutate(record.name)}
//                   // onCancel={cancel}
//                   okText={t.yes}
//                   cancelText={t.no}
//                 >
//                   <Button size="small" type="primary" danger>
//                     <MdDelete />
//                   </Button>
//                 </Popconfirm>
//           }
//               </Space>
//             );
//           },
//         },
//       ];
//       return {columns, searchText, setSearchText};
// }

// export default PaymentAction
